export default __webpack_public_path__ + "static/media/030-anthropology.27049442.svg";